import { App } from 'config/setup';
import { renderMainLayout } from 'services/render-main-layout';
import { initializeTrackingTools } from 'services/startup/initialize/initialize-tracking-tools';

import { initializeBase } from './initialize-base';

export function initializeFreeAccessPage(path: string): void {
  initializeBase();
  initializeTrackingTools();
  renderMainLayout();
  App.visitInfoPage?.(path);
}
